/**
 * / — Public landing. Surface Layer (/01)
 *
 * Anonymous visitors get a public entry page (sign-in / request-access CTAs);
 * authenticated visitors are redirected to the protected, plane-split
 * `/dashboard`. No authenticated data is read or rendered here.
 */

import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { Button, Stack, Theme } from '@carbon/react';
import { ArrowRight, Login } from '@carbon/icons-react';
import { useAuthStore } from '@auth/auth-store';
import './sign-in.scss';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (useAuthStore.getState().identity) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: PublicLanding,
});

function PublicLanding() {
  const navigate = useNavigate();
  return (
    <Theme theme="g100">
      <main className="sign-in-page">
        <section className="sign-in-card" aria-labelledby="public-landing-heading">
          <Login size={32} aria-hidden="true" className="sign-in-card__icon" />
          <h1 id="public-landing-heading" className="sign-in-card__heading">
            Cestari Studio
          </h1>
          <p className="sign-in-card__subtitle">
            A private, local-first studio workspace. Sign in to your hub, or request access.
          </p>
          <Stack gap={6}>
            <Button kind="primary" renderIcon={ArrowRight} onClick={() => void navigate({ to: '/login' })}>
              Sign in
            </Button>
            <Button kind="tertiary" onClick={() => void navigate({ to: '/support' })}>
              Request access
            </Button>
          </Stack>
        </section>
      </main>
    </Theme>
  );
}
